module.exports = __webpack_public_path__ + "static/Icon-3e968363470e88a68d4a1641fde33f6d.png";